<div class="buttons-container">
  <mojo-feedback-panel
    *ngIf="!disableFeedback"
    [ngClass]="{'display-only-hover':
    (isMobileView$ | async) === false &&
    !showButtonsAlways &&
    !feedback &&
    !candidateCardActive,
    'hover': cardHover}"
    [jobId]="job?.id"
    [candidateId]="candidate?.id"
    [showOnHover]="!showButtonsAlways"
    [isCandidateCardHovered]="cardHover"
    [feedback]="feedback"
    [totalThumbsUp]="totalThumbsUp"
    [isMobileView]="isMobileView$ | async"
    (feedbackPanelOpened)="feedbackPanelOpened.emit($event)"
  >
  </mojo-feedback-panel>
</div>
